import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";
import { ConfigContainerChild } from "../types";

export const getSlideshowImages = ({
  element,
  attribute,
}: {
  element: ConfigContainerChild;
  attribute: FeatureAttribute;
}): string[] => {
  const { defaultValue, options } = element;
  const { separator } = options || {};

  return element.value
    ? [element.value as string]
    : (attribute?.value as string)
    ? (attribute.value as string).split(separator || ";")
    : (defaultValue as string)
    ? [defaultValue as string]
    : [];
};
